define('modules/editor/views/property_boxes/idclass',['require','exports','module','./base','ldsh!../../templates/property_boxes/idclass'],function(require,exports,module){
  "use strict";
  var BasePropertyBox = require("./base");
  module.exports = BasePropertyBox.extend({
    template: require("ldsh!../../templates/property_boxes/idclass")
  });
});
